import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'om-svg-caret-up',
  template: `
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.77" d="M0.5 8.5L7.5 1.5L14.5 8.5" [attr.stroke]="stroke" />
    </svg>
  `,
  styleUrls: [],
})
export class SvgCaretUpComponent implements OnInit {
  @Input() stroke = '#1A1A1A';

  constructor() {}

  ngOnInit() {}
}
